import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { Subject } from 'rxjs/Subject';
import { CommonService } from '../../services/common/common.service';
import { UserService } from "../../services/user/user.service";
import * as moment from 'moment';
import { data } from 'jquery';
@Injectable()
export class WidgetHelperService {
  hours: string[] = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];
  weekDays: string[] = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  months: string[] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  daysInMonth: string[] = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31"];
  hour: string[] = [];
  week: string[] = [];
  month: string[] = [];
  columns: any = ["label", "value", "date"];
  trendColor = ["#4DD0E1", "#4DB6AC", "#00897B", "#A5D6A7", "#43A047", "#E6EE9C", "#C0CA33", "#FFF59D", "#FDD835", "#F06292", "#9FA8DA", "#9CCC65", "#A7FFEB", "#DCEDC8", "#A1887F"];


  constructor(private httpClient: HttpClient, private commonService: CommonService, public userService: UserService) {

  }

  getRandomRgb() {
    var letters = 'BCDEF'.split('');
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * letters.length)];
    }

    let hex = color.replace('#', '');
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    return 'rgba(' + r + ', ' + g + ', ' + b + ',0.4)';
  }

  getHours() {
    return this.hours;
  }

  getWeekDays() {
    return this.weekDays;
  }

  getMonths() {
    return this.months;
  }

  filterData(componentData) {
    let dataFilters = componentData.dataFilter;
    let timeFrame = componentData.timeFrame;
    let showSpecificDate = componentData.udf.showSpecificDate;
    if (showSpecificDate.length == 0) {
      return componentData;
    }

    dataFilters.forEach((df, i) => {
      let tempData = [];

      df.data.forEach((data) => {
        let date: any = new Date(data.dateFrom);

        //hours
        if (timeFrame == "hour") {
          let hour = this.commonService.addZero(date.getHours()) + ":00";
          if (showSpecificDate.includes(hour)) {
            tempData.push(data)
          }
        }

        //day of week
        else if (timeFrame == "dayOfWeek") {
          if (showSpecificDate.includes(date.getDay())) {
            tempData.push(data)
          }
        }

        //day of month
        else if ((timeFrame == "dayOfMonth")) {
          if (showSpecificDate.includes(this.commonService.getMDYDate(date))) {
            tempData.push(data)
          }
        }

        //week
        else if (timeFrame == "week") {
          if (showSpecificDate.includes(date.getWeek())) {
            tempData.push(data)
          }
        }

        //month
        else if (timeFrame == "month") {
          if (showSpecificDate.includes(date.getMonths() + 1)) {
            tempData.push(data)
          }
        }

        //year
        else if (timeFrame == "year") {
          if (showSpecificDate.includes(date.getFullYear())) {
            tempData.push(data)
          }
        }

      });

      componentData.dataFilter[i].data = tempData;
    });

    return componentData;
  }

  getCompareCategories(_compData, groupData) {
    let compareCategories = [];
    if (_compData.udf.compareConfig.displayRange == "selected")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.displayName);
    else if (_compData.udf.compareConfig.displayRange == "dateRange1")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.range1.displayName);
    else if (_compData.udf.compareConfig.displayRange == "dateRange2")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.range2.displayName);
    else if (_compData.udf.compareConfig.displayRange == "dateRange3")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.range3.displayName);
    else if (_compData.udf.compareConfig.displayRange == "dateRange4")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.range4.displayName);
    else if (_compData.udf.compareConfig.displayRange == "dateRange5")
      compareCategories = this.getCompareDates(_compData, _compData.udf.compareConfig.range5.displayName);
    else if (_compData.udf.compareConfig.displayRange == "numbered") {
      let noObj: any = [];
      _compData.dataFilter.filter(function (e) {
        noObj.push(e.data.length);
      });
      for (let index = 0; Math.max(...noObj) > index; index++) {
        compareCategories.push(index + 1)
      }
    }
    return compareCategories;
  }

  getCompareDates(_compData, label) {
    let dates = [];
    let selectedObj = _compData.dataFilter.find(x => x.rangeLabel == label).data;
    let nonObj = _compData.dataFilter.filter((x) => x.rangeLabel != label);

    selectedObj.forEach(el => {
      dates.push(el.date);
    });

    nonObj.forEach(el => {
      if (el.data.length > selectedObj.length) {
        for (let index = selectedObj.length; index < el.data.length; index++) {
          dates.push(el.data[index].date);
        }
      }
    });
    return dates;
  }

  getGraphCategories(componentData, groupData) {
    let graphCategories = [];
    let timeFrame = componentData.timeFrame;
    let consolidateData = componentData.udf.consolidateData;

    // componentData.from = this.commonService.parseToDbDateStartOfTheDay(componentData.from);
    // componentData.to = this.commonService.parseToDbDateEndOfTheDay(componentData.to);

    let fromDate = new Date(this.commonService.getDateConverted(componentData.from, "YYYY-MM-DD HH:mm:ss"));
    let toDate = new Date(this.commonService.getDateConverted(componentData.to, "YYYY-MM-DD HH:mm:ss"));

    // let offsetV = this.commonService.getOffsetValueFromSetting(offset);
    // let a = new Date(componentData.from)

    // let fromDate =  new Date(moment(componentData.from).utcOffset(offsetV).format('YYYY-MM-DD HH:mm:ss')); //new Date(componentData.from + " UTC");
    // let toDate = new Date(moment(componentData.to).utcOffset(offsetV).format('YYYY-MM-DD HH:mm:ss'));//new Date(componentData.to + " UTC");

    // //Handling for firefox since UTC NEW DATE HAVING ISSUE
    // if(fromDate.toString() == "Invalid Date" ){
    //   fromDate = moment.utc(componentData.from,"YYYY-MM-DD HH:mm:ss").toDate();
    // }
    // if(toDate.toString() == "Invalid Date"){
    //   toDate=moment.utc(componentData.to,"YYYY-MM-DD HH:mm:ss").toDate();
    // }


    // let showSpecificDate = componentData.udf.showSpecificDate || [];

    let showSpecificDate = [];

    if (groupData.showDataByOperationalHours && componentData.kpiType == "numeric" && groupData.groupByTimeFrame == "hour") {
      showSpecificDate = groupData.operationHours;
    }
    else {
      showSpecificDate = componentData.udf.showSpecificDate || [];
    }

    let sSDl = showSpecificDate.length;
    let sy = fromDate.getFullYear();//start year
    let ey = toDate.getFullYear();//end year

    //hours
    if (timeFrame == "hour") {
      if (consolidateData == 1) {

        this.hours.forEach(h => {

          //if specific hour selected
          if (sSDl > 0) {
            if (showSpecificDate.includes(h)) {
              graphCategories.push(h);
            }
          } else {
            graphCategories.push(h);
          }

        })

      }
      else {
        graphCategories = [];
        while (fromDate <= toDate) {

          this.hours.forEach(h => {

            //if specific hour selected
            if (sSDl > 0) {
              if (showSpecificDate.includes(h)) {
                graphCategories.push(this.commonService.getMDYDate(fromDate) + " " + h);
              }
            } else {
              graphCategories.push(this.commonService.getMDYDate(fromDate) + " " + h);
            }

          })
          fromDate.setDate(fromDate.getDate() + 1);
        }
      }
    }

    //day of week
    else if (timeFrame == "dayOfWeek" && consolidateData == 1) {
      graphCategories = this.weekDays;
    }

    //day of month
    else if ((timeFrame == "dayOfMonth" || timeFrame == "dayOfWeek" && consolidateData != 1)) {

      while (fromDate <= toDate) {
        let day = "";
        let dayIndex = 0;
        if (timeFrame == "dayOfWeek") {
          dayIndex = (fromDate.getDay() == 0 ? 6 : fromDate.getDay() - 1);
          day = this.weekDays[dayIndex] + " ";
        }

        //if specific hour selected
        if (sSDl > 0) {
          if (showSpecificDate.includes(this.commonService.getMDYDate(fromDate)) || showSpecificDate.includes(dayIndex + 1)) {
            graphCategories.push(day + this.commonService.getMDYDate(fromDate));
          }
        } else {
          graphCategories.push(day + this.commonService.getMDYDate(fromDate));
        }

        fromDate.setDate(fromDate.getDate() + 1);
      }
    }

    //week
    else if (timeFrame == "week") {

      if (consolidateData == 1) {
        for (var i = 0; i <= 53; i++) {
          if (sSDl > 0) {
            showSpecificDate.forEach(ssd => {
              if (i == ssd) {
                graphCategories.push("week " + this.commonService.addZero(i));
              }
            });
          } else {
            graphCategories.push("week " + this.commonService.addZero(i));
          }
        }

      } else {

        for (var j = sy; j <= ey; j++) {
          for (var i = 0; i <= 53; i++) {
            if (sSDl > 0) {
              showSpecificDate.forEach(ssd => {
                if (i == ssd) {
                  graphCategories.push("week " + this.commonService.addZero(i) + " " + j);
                }
              });
            } else {
              graphCategories.push("week " + this.commonService.addZero(i) + " " + j);
            }
          }
        }
      }
    }

    //month
    else if (timeFrame == "month") {

      if (consolidateData == 1) {

        this.months.forEach((m, i) => {
          if (sSDl > 0) {
            showSpecificDate.forEach(ssd => {
              if ((i + 1) == ssd) {
                graphCategories.push(m);
              }
            });
          } else {
            graphCategories.push(m);
          }
        });

      } else {

        for (var j = sy; j <= ey; j++) {
          this.months.forEach((m, i) => {
            if (sSDl > 0) {
              showSpecificDate.forEach(ssd => {
                if ((i + 1) == ssd) {
                  graphCategories.push(this.commonService.addZero(i + 1) + "-" + j);
                }
              });
            } else {
              graphCategories.push(this.commonService.addZero(i + 1) + "-" + j);
            }
          });
        }
      }
    }

    //year
    else if (timeFrame == "year") {

      for (var j = sy; j <= ey; j++) {
        if (sSDl > 0) {
          showSpecificDate.forEach(ssd => {
            if (j == ssd) {
              graphCategories.push(j);
            }
          });
        } else {
          graphCategories.push(j);
        }
      }
    }
    if (groupData.consolidateDate === 1 && ['week', 'month', 'year'].includes(timeFrame) && componentData.dataFilter.length > 0) {
      graphCategories = [];
      var filter = componentData.dataFilter.find(x => x.data.length > 0);
      graphCategories.push(filter.data[0].date);
      componentData.dataFilter.forEach(x => {
        if (x.data[0] && x.data[0].date.toString().indexOf('to') == -1)
          x.data[0].date = graphCategories[0];
      });
      return graphCategories;
    }
    else if (groupData.consolidateDate === 1 && !['week', 'month', 'year'].includes(timeFrame)) {
      graphCategories = [graphCategories[0] + ' to ' + graphCategories[graphCategories.length - 1]];
      componentData.dataFilter.forEach(x => {
        if (x.data[0] && x.data[0].date.toString().indexOf('to') == -1)
          x.data[0].date = graphCategories[0];
      });
    }
    return graphCategories;
  }

  getGraphCategoriesFromData(componentData, groupData) {
    let graphCategories = [];
    let timeFrame = componentData.timeFrame;
    let consolidateData = componentData.udf.consolidateData;
    let minDate = componentData.from, maxDate = componentData.to;
    if (groupData.showDataByOperationalHours == 1 && timeFrame=='hour') {
      let _mdt=[];
      componentData.dataFilter.map((df) => {
        _mdt = _mdt.concat(df.data.map(d => moment(d.date,'DD-MM-YYYY HH:mm')));       
      });
      minDate = moment.min(_mdt).format("YYYY-MM-DD HH:mm:ss");
      maxDate = moment.max(_mdt).format("YYYY-MM-DD HH:mm:ss");
      _mdt=[];
    }
    // let fromDate = new Date(this.commonService.getDateConverted(minDate, "YYYY-MM-DD HH:mm:ss"));
    // let toDate = new Date(this.commonService.getDateConverted(maxDate, "YYYY-MM-DD HH:mm:ss"));
    let fromDate = new Date(this.commonService.getDateConverted(minDate, "YYYY-MM-DD HH:mm:ss"));
    let toDate = new Date(this.commonService.getDateConverted(maxDate, "YYYY-MM-DD HH:mm:ss"));

    let showSpecificDate = [];

    // if (groupData.showDataByOperationalHours && componentData.kpiType == "numeric" && groupData.groupByTimeFrame == "hour") {
    //   showSpecificDate = groupData.operationHours;
    // }
    // else {
    //   showSpecificDate = componentData.udf.showSpecificDate || [];
    // }
    showSpecificDate = componentData.udf.showSpecificDate || [];
    let sSDl = showSpecificDate.length;
    let sy = fromDate.getFullYear();//start year
    let ey = toDate.getFullYear();//end year

    //hours
    if (timeFrame == "hour") {
      if (consolidateData == 1) {

        this.hours.forEach(h => {

          //if specific hour selected
          if (sSDl > 0) {
            if (showSpecificDate.includes(h)) {
              graphCategories.push(h);
            }
          } else {
            graphCategories.push(h);
          }

        })

      }
      else {
        graphCategories = [];
        while (moment(fromDate).valueOf() <= moment(toDate).valueOf()) {

          this.hours.forEach((h,index) => {
            if(moment(fromDate).valueOf() <= moment(toDate).valueOf()){
              //if specific hour selected
              if (sSDl > 0) {
                if (showSpecificDate.includes(h)) {
                  graphCategories.push(this.commonService.getMDYDate(fromDate) + " " + h);
                }
              } else {
                graphCategories.push(this.commonService.getMDYDate(fromDate) + " " + h);
              }
              fromDate.setHours(index+1);
            }
          })
          // fromDate.setDate(fromDate.getDate() + 1);
        }
      }
    }

    //day of week
    else if (timeFrame == "dayOfWeek" && consolidateData == 1) {
      graphCategories = this.weekDays;
    }

    //day of month
    else if ((timeFrame == "dayOfMonth" || timeFrame == "dayOfWeek" && consolidateData != 1)) {

      while (fromDate <= toDate) {
        let day = "";
        let dayIndex = 0;
        if (timeFrame == "dayOfWeek") {
          dayIndex = (fromDate.getDay() == 0 ? 6 : fromDate.getDay() - 1);
          day = this.weekDays[dayIndex] + " ";
        }

        //if specific hour selected
        if (sSDl > 0) {
          if (showSpecificDate.includes(this.commonService.getMDYDate(fromDate)) || showSpecificDate.includes(dayIndex + 1)) {
            graphCategories.push(day + this.commonService.getMDYDate(fromDate));
          }
        } else {
          graphCategories.push(day + this.commonService.getMDYDate(fromDate));
        }

        fromDate.setDate(fromDate.getDate() + 1);
      }
    }

    //week
    else if (timeFrame == "week") {

      if (consolidateData == 1) {
        for (var i = 0; i <= 53; i++) {
          if (sSDl > 0) {
            showSpecificDate.forEach(ssd => {
              if (i == ssd) {
                graphCategories.push("week " + this.commonService.addZero(i));
              }
            });
          } else {
            graphCategories.push("week " + this.commonService.addZero(i));
          }
        }

      } else {

        for (var j = sy; j <= ey; j++) {
          for (var i = 0; i <= 53; i++) {
            if (sSDl > 0) {
              showSpecificDate.forEach(ssd => {
                if (i == ssd) {
                  graphCategories.push("week " + this.commonService.addZero(i) + " " + j);
                }
              });
            } else {
              graphCategories.push("week " + this.commonService.addZero(i) + " " + j);
            }
          }
        }
      }
    }

    //month
    else if (timeFrame == "month") {

      if (consolidateData == 1) {

        this.months.forEach((m, i) => {
          if (sSDl > 0) {
            showSpecificDate.forEach(ssd => {
              if ((i + 1) == ssd) {
                graphCategories.push(m);
              }
            });
          } else {
            graphCategories.push(m);
          }
        });

      } else {

        for (var j = sy; j <= ey; j++) {
          this.months.forEach((m, i) => {
            if (sSDl > 0) {
              showSpecificDate.forEach(ssd => {
                if ((i + 1) == ssd) {
                  graphCategories.push(this.commonService.addZero(i + 1) + "-" + j);
                }
              });
            } else {
              graphCategories.push(this.commonService.addZero(i + 1) + "-" + j);
            }
          });
        }
      }
    }

    //year
    else if (timeFrame == "year") {

      for (var j = sy; j <= ey; j++) {
        if (sSDl > 0) {
          showSpecificDate.forEach(ssd => {
            if (j == ssd) {
              graphCategories.push(j);
            }
          });
        } else {
          graphCategories.push(j);
        }
      }
    }
    if (groupData.consolidateDate === 1 && ['week', 'month', 'year'].includes(timeFrame) && componentData.dataFilter.length > 0) {
      graphCategories = [];
      var filter = componentData.dataFilter.find(x => x.data.length > 0);
      if(filter){
        graphCategories.push(filter.data[0].date);
      }
      componentData.dataFilter.forEach(x => {
        if (x.data[0] && x.data[0].date.toString().indexOf('to') == -1)
          x.data[0].date = graphCategories[0];
      });
      return graphCategories;
    }
    else if (groupData.consolidateDate === 1 && !['week', 'month', 'year'].includes(timeFrame)) {
      graphCategories = [graphCategories[0] + ' to ' + graphCategories[graphCategories.length - 1]];
      componentData.dataFilter.forEach(x => {
        if (x.data[0] && x.data[0].date.toString().indexOf('to') == -1)
          x.data[0].date = graphCategories[0];
      });
    }
    return graphCategories;
  }

  // getEventData(componentData, graphCategories = []) {
  //   let eventData = [];
  //   let events = this.getEventDataTimeFrameWise(componentData, graphCategories);
  //   events
  //     .forEach((v, i) => {
  //       let tempArr = {
  //         color: this.getRandomRgb(), // Color value
  //         from: v.from, // Start of the plot band
  //         to: v.to,
  //         borderColor: "black",
  //         borderWidth: 2,
  //         label: {
  //           style: {
  //             color: '#8e8e8e'
  //           },
  //           x: 10,
  //           rotation: 90,
  //           textAlign: 'left',
  //           align: 'left',
  //           useHTML: true,
  //           text: '&nbsp;' + v.eventName
  //         },
  //         id: `e_${v.eventId}`
  //       };

  //       eventData.push(tempArr);
  //     });

  //   return eventData;
  // }

  getEventData(componentData, graphCategories = []) {
    let eventData = [];
    let events = this.getEventDataTimeFrameWise(componentData, graphCategories);
    events
      .forEach((v, i) => {
        // let tempArr = {
        //   color: this.getRandomRgb(), // Color value
        //   from: v.from, // Start of the plot band
        //   to: v.to,
        //   borderColor: "black",
        //   borderWidth: 2,
        //   label: {
        //     style: {
        //       color: '#8e8e8e'
        //     },
        //     x: 10,
        //     rotation: 90,
        //     textAlign: 'left',
        //     align: 'left',
        //     useHTML: true,
        //     text: '&nbsp;' + v.eventName
        //   },
        //   id: `e_${v.eventId}`
        // };
        eventData.push({
          dashStyle: 'dash',
          width: 2,
          color: '#727272',
          value: v.from,
          label: {
            style: {
              color: '#8e8e8e'
            },
            x: 10,
            rotation: 90,
            textAlign: 'left',
            align: 'left',
            useHTML: true,
            text: '&nbsp;' + v.eventName + ' begins'
          }
        }, {
          dashStyle: 'dash',
          width: 2,
          color: '#727272',
          value: v.to,
          label: {
            style: {
              color: '#8e8e8e'
            },
            x: 10,
            rotation: -270,
            textAlign: 'left',
            align: 'left',
            useHTML: true,
            text: '&nbsp;' + v.eventName + ' ends'
          },
        });
      });



    return eventData;
  }

  getEventDataTimeFrameWise(componentData, graphCategories) {
    let events = [];
    let timeFrame = componentData.timeFrame;
    let consolidateData = componentData.udf.consolidateData;
    let weekDiff = 0;
    let maxDataLength = 0;
    let siteLabel = [];
    componentData.dataFilter.forEach(d => {

      //take weekDiff so we can minus week to sort startDay of week
      if (d.data.length > 0 && weekDiff == 0 && timeFrame == "week") {

      }

      if (maxDataLength < d.data.length) {
        maxDataLength = d.data.length;
      }

      d.siteIds.forEach(s => {
        let a = { siteId: s, label: d.label };
        siteLabel.push(a);
      });

    });

    componentData.events
      .forEach((v, i) => {
        v = Object.assign({}, v);


        let from: any = new Date(v.from.replace("Z", ""));
        let to: any = new Date(v.to.replace("Z", ""));
        let eventId = "";

        v.mapped.forEach(m => {

          //get all sites mapped with event
          let mappedSite = siteLabel.filter(sl => sl.siteId == m.siteId);
          if (mappedSite && mappedSite.length > 0) {
            eventId = mappedSite.map(ms => ms.label).join(",");
          }
        });


        v.eventId = eventId;


        //hours
        if (timeFrame == "hour") {
          if (consolidateData == 1) {
            v.from = this.commonService.addZero(from.getHours()) + ":00";
            v.to = this.commonService.addZero(to.getHours()) + ":00";
          } else {
            v.from = this.commonService.getMDYDate(from) + " " + this.commonService.addZero(from.getHours()) + ":00";
            v.to = this.commonService.getMDYDate(to) + " " + this.commonService.addZero(to.getHours()) + ":00";
          }
        }

        //day of week
        else if (timeFrame == "dayOfWeek" && consolidateData == 1) {
          v.from = this.weekDays[(from.getDay() == 0 ? 6 : from.getDay() - 1)];
          v.to = this.weekDays[(to.getDay() == 0 ? 6 : to.getDay() - 1)];
        }

        //day of month
        else if ((timeFrame == "dayOfMonth" || timeFrame == "dayOfWeek" && consolidateData != 1)) {
          if (timeFrame == "dayOfWeek") {
            v.from = this.weekDays[(from.getDay() == 0 ? 6 : from.getDay() - 1)] + " " + this.commonService.getMDYDate(from);
            v.to = this.weekDays[(to.getDay() == 0 ? 6 : to.getDay() - 1)] + " " + this.commonService.getMDYDate(to);
          } else {
            v.from = this.commonService.getMDYDate(from);
            v.to = this.commonService.getMDYDate(to);
          }
        }


        //week
        else if (timeFrame == "week") {

          /*we have removed this code because date worked iso8601
          try {
            let userInfo = this.commonService.getUserSetting();
            let weekNo = userInfo.startOfWeek ? parseInt(userInfo.startOfWeek) : 0 || 0;
            if(weekNo == 0){
              try{
                var start = new Date("1/1/"+ from.getFullYear());
                if(weekNo < start.getDay()){
                  weekNo = (7 - start.getDay());
                }
              }catch(ex){}

              if(weekNo > 3){
                weekDiff = 1;
              }
            }
          } catch (ex) { }*/

          if (consolidateData == 1) {
            v.from = "week " + (from.getWeek() + weekDiff);
            v.to = "week " + (to.getWeek() + weekDiff);
          } else {
            v.from = "week " + (from.getWeek() + weekDiff) + " " + from.getFullYear();
            v.to = "week " + (to.getWeek() + weekDiff) + " " + to.getFullYear();
          }
        }



        //month
        else if (timeFrame == "month") {

          if (consolidateData == 1) {
            v.from = this.months[from.getMonth()];
            v.to = this.months[to.getMonth()];
          } else {
            v.from = this.commonService.addZero(from.getMonth() + 1) + "-" + from.getFullYear();
            v.to = this.commonService.addZero(to.getMonth() + 1) + "-" + to.getFullYear();
          }
        }


        //year
        else if (timeFrame == "year") {
          v.from = from.getFullYear();
          v.to = to.getFullYear();
        }

        if (timeFrame != "custom" && timeFrame != "year") {
          graphCategories.forEach((g, j) => {
            if (v.from == g) {
              v.from = j
            }
            if (v.to == g) {
              v.to = j
            }
          });
        }

        //check for multiple event on same line
        let hasEvent = false;
        if (timeFrame != "hour" && v.from == v.to) {
          events.forEach((e, j) => {
            if (v.from == e.from && e.from == e.to) {
              try {
                if (e.eventName.search("events inside") != -1) {
                  let ec = e.eventName.replace(" events inside", "");
                  ec = parseInt(ec) + 1;
                  events[j].eventName = ec + " events inside";
                } else {
                  events[j].eventName = "2 events inside";
                }

                //append current event id
                events[j].eventId += v.eventId;

                hasEvent = true;
              } catch (ex) {

              }
            }
          });
        }
        if (!hasEvent) {
          events.push(v);
        }
      });

    return events;
  }

  getYAxisConfig(componentData) {
    let axisConfig = componentData.udf.axisConfig;
    let y1AxisAvaialble = 0;
    let y2AxisAvaialble = 0;

    //set yAxis
    let yAxisData: any = [{
      title: {
        text: ""
      }
    }];

    //check if axis is available
    componentData.dataFilter.forEach((v, i) => {
      // check if y1 axis is available
      if (v.showOnAxis == "y1") {
        y1AxisAvaialble += 1;
      };
      // check if y2 axis is available
      if (v.showOnAxis == "y2") {
        y2AxisAvaialble += 1;
      };
    });

    if (axisConfig) {
      if (y1AxisAvaialble > 0 && y2AxisAvaialble > 0) {
        yAxisData = [{
          allowDecimals: (axisConfig.y1.decimals && axisConfig.y1.decimals > 0 ? true : false),
          title: {
            text: (axisConfig.y1.label ? axisConfig.y1.label : "")
          }
        }, {
          allowDecimals: (axisConfig.y2.decimals && axisConfig.y2.decimals > 0 ? true : false),
          title: {
            text: (axisConfig.y2.label ? axisConfig.y2.label : "")
          },
          opposite: true
        }];
      } else if (y1AxisAvaialble == 0 && y2AxisAvaialble > 0) {
        yAxisData = [{
          allowDecimals: (axisConfig.y1.decimals && axisConfig.y1.decimals > 0 ? true : false),
          title: {
            text: ""
          }
        }, {
          allowDecimals: (axisConfig.y2.decimals && axisConfig.y2.decimals > 0 ? true : false),
          title: {
            text: (axisConfig.y2.label ? axisConfig.y2.label : "")
          },
          opposite: true
        }];
      } else {
        yAxisData = [{
          allowDecimals: (axisConfig.y1.decimals && axisConfig.y1.decimals > 0 ? true : false),
          title: {
            text: (axisConfig.y1.label ? axisConfig.y1.label : "")
          }
        }];
      }
    };


    return yAxisData;
  }


  getXAxisConfig(componentData, groupData) {
    let xAxis = {};
    if (componentData.timeFrame == 'custom') {
      xAxis = {
        type: 'datetime',
        title: {
          text: ""
        },
        plotLines: this.getEventData(componentData)
      }
    } else if (componentData.kpiType == "comparison") {
      let categories = this.getCompareCategories(componentData, groupData);
      xAxis = {
        type: "category",
        categories: categories,
        title: {
          text: ""
        },
      }
    } else {
      let categories = this.getGraphCategoriesFromData(componentData, groupData);
      xAxis = {
        type: "category",
        categories: categories,
        title: {
          text: ""
        },
        plotLines: this.getEventData(componentData, categories)
      }
    }
    return xAxis;
  }

  getXAxisConfigForHistogram(componentData, groupData) {
    let xAxis = {};
    let categories = this.getHistogramCategories(componentData, groupData);
    xAxis = {
      type: "category",
      categories: categories,
      title: {
        text: ""
      }
    }
    return xAxis;
  }

  getHistogramCategories(componentData, groupData) {
    let graphCategories = [];
    if (componentData.udf.histogramConfig.rangeType == 'date') {
      if (componentData.udf.histogramConfig.valueType == 'absolute') {
        componentData.binFilter.forEach((bin, i) => {
          if (bin.label != '') {
            graphCategories.push(bin.label)
          } else {
            let binval = '';
            if (bin.maxonly) {
              let _max = moment(bin.max).toDate();
              binval = '>' + _max.getDate() + '-' + (_max.getMonth() + 1) + '-' + _max.getFullYear();
            }
            else if (bin.minonly) {
              let _min = moment(bin.min).toDate();
              binval = '<' + _min.getDate() + '-' + (_min.getMonth() + 1) + '-' + _min.getFullYear()
            }
            else {
              var _min = moment(bin.min).toDate();
              var _max = moment(bin.max).toDate();
              binval = _min.getDate() + '-' + (_min.getMonth() + 1) + '-' + _min.getFullYear() + ' to ' + _max.getDate() + '-' + (_max.getMonth() + 1) + '-' + _max.getFullYear()
            }
            if (bin.dayselection == 1)
              binval += ' (Weekdays)';
            if (bin.dayselection == 2)
              binval += ' (Weekends)'
            graphCategories.push(binval)
          }

        });
      }
      else {
        componentData.binFilter.forEach((bin, i) => {
          if (bin.label != '') {
            graphCategories.push(bin.label)
          } else {
            let binval = '';
            if (bin.maxonly) {
              let _max = moment().subtract(bin.max, 'days').toDate();
              binval = '>' + _max.getDate() + '-' + (_max.getMonth() + 1) + '-' + _max.getFullYear()
            }
            else if (bin.minonly) {
              let _min = moment().subtract(bin.min, 'days').toDate();
              binval = '<' + _min.getDate() + '-' + (_min.getMonth() + 1) + '-' + _min.getFullYear()
            }
            else {
              var _min = moment().subtract(bin.min, 'days').toDate();
              var _max = moment().subtract(bin.max, 'days').toDate();
              binval = _min.getDate() + '-' + (_min.getMonth() + 1) + '-' + _min.getFullYear() + ' to ' + _max.getDate() + '-' + (_max.getMonth() + 1) + '-' + _max.getFullYear()
            }
            if (bin.dayselection == 1)
              binval += '(Week Day)';
            if (bin.dayselection == 2)
              binval += '(Weekend)'
            graphCategories.push(binval)
          }
        });

      }
    }
    else {
      componentData.binFilter.forEach((bin, i) => {
        if (bin.label != '') {
          graphCategories.push(bin.label)
        }
        else {
          let binval = '';
          if (bin.maxonly) {
            binval = '>' + bin.max
          }
          else if (bin.minonly) {
            binval = '<' + bin.min
          }
          else {
            binval = bin.min + ' - ' + bin.max;
          }
          graphCategories.push(binval)
        }
      });
    }

    return graphCategories;
  }

  getHistogramSeriesData(componentData) {
    // console.log(componentData);
    let seriesList = [];
    let timeFrame = componentData.timeFrame;
    var len = componentData.dataFilter.length * componentData.binFilter.length;
    componentData.dataFilter.forEach((v, i) => {
      let seriesData = [];
      let dataLabels = this.getSeriesDataLabel(componentData, i);

      //set series
      let singleSeries: any = {
        name: v.label,
        data: [],
        color: v.color,
        yAxis: (v.showOnAxis == "y2" ? 1 : 0),
        dataLabels: dataLabels
      }

      //add data
      if (["hour", "dayOfMonth", "dayOfWeek", "week", "month", "year", "custom"].includes(timeFrame)) {
        v.data.forEach(data => {
          seriesData.push(data.value);
        });
      }
      singleSeries.data = seriesData;
      if (len < 20)
        singleSeries['pointWidth'] = 40
      seriesList.push(singleSeries);
    });

    return seriesList;
  }

  getSeriesData(componentData) {
    let that = this;
    let seriesList = [];
    let consolidateData = componentData.udf.consolidateData;
    let timeFrame = componentData.timeFrame;
    componentData.dataFilter.forEach((v, i) => {
      let seriesData = [];      
      let dataLabels = this.getSeriesDataLabel(componentData, i);
      //set decimals value
      let decimals = 0;
      if (componentData.udf.axisConfig) {
        decimals = (v.showOnAxis == "y1" ? componentData.udf.axisConfig.y1.decimals : componentData.udf.axisConfig.y2.decimals);
      };
      if (!v.fetchDataFor) {
        v.fetchDataFor = "";
      }
      v.fetchDataFor = v.fetchDataFor == "bar" ? "column" : v.fetchDataFor;
      //set series
      let singleSeries: any = {
        type: v.fetchDataFor,
        name: v.label,
        boostThreshold:50000,
        data: [],
        color: v.color,
        yAxis: (v.showOnAxis == "y2" ? 1 : 0),
        tooltip: {
          pointFormat: v.label + ": {point.y:." + decimals + "f}",
          pointFormatter: function () {
            let dv = v.data[this.index].derviedLabel;
            let val = this.y
            val = (componentData.udf.kpiNumberConfig[i].kpiNumberFormat == "-1" ? that.commonService.shortNumberFormat(val) : parseFloat(val).toFixed(componentData.udf.kpiNumberConfig[i].kpiNumberFormat));
            if (v.isThousandSeperator)
              val = that.commonService.formatNumberString(val, true);
            else
              val = that.commonService.formatNumberString(val, false);
            if (dv && dv != '')
              return dv + ": " + val;//this.y.toFixed(decimals);
            else
              return v.label + ": " + val+`${(componentData.kpiType == "numeric" && v.fetchDataFor == 'column' && v.displayType == 'percentage') ? "%" : ""}`;//this.y.toFixed(decimals); added by ravi
          }
        },
        dataLabels: dataLabels
      }

      //add data
      if (["hour", "dayOfMonth", "dayOfWeek", "week", "month", "year", "custom"].includes(timeFrame)) {
        if (consolidateData == 1 && ["hour","month"].includes(timeFrame)) {                      
          v.data.sort((c, d) => {
            let aa = Number(c.date);
            let bb = Number(d.date);
            return aa > bb ? 1 : aa < bb ? -1 : 0;
          });
        }

        if (timeFrame == "hour") {
          if (consolidateData == 1) {
            v.data.sort((c, d) => {
              let aa = Number(c.date);
              let bb = Number(d.date);
              return aa > bb ? 1 : aa < bb ? -1 : 0;
            });
          }
          else{
            v.data.sort((c, d) => {
              let aa = moment.utc(c.date, 'DD-MM-YYYY HH:mm').valueOf();
              let bb = moment.utc(d.date, 'DD-MM-YYYY HH:mm').valueOf();
              return aa > bb ? 1 : aa < bb ? -1 : 0;
            });           
          }
        }

        // console.log(componentData)
        v.data.forEach(data => {
          let vd = data.value;
          let d = data.date;

          if (consolidateData == 1 && timeFrame == "hour") {            
            d = this.commonService.addZero(d) + ":00";
          }
          if (consolidateData == 1 && timeFrame == "dayOfWeek") {
            d = this.weekDays[d - 1];
          }
          if (consolidateData != 1 && timeFrame == "dayOfWeek") {
            d = d.split("|");
            d = this.weekDays[d[0] - 1] + " " + d[1];
          }
          if (timeFrame == "week") {
            d = "week " + d;
          }
          if (consolidateData == 1 && timeFrame == "month") {
            d = this.months[d - 1];
          }
          if (timeFrame == "custom") {
            d = Date.parse(data.dateFrom);
          }

          //apply decimal //give priority to kpi decimal format
          // if (decimals != 0) {
          //   vd = parseFloat(vd.toFixed(decimals));
          // } else {
          //   vd = Math.round(vd);
          // }
          vd = Number(componentData.udf.kpiNumberConfig[i].kpiNumberFormat == "-1" ? Math.round(vd) : parseFloat(vd).toFixed(componentData.udf.kpiNumberConfig[i].kpiNumberFormat));
          seriesData.push([d, vd]);
        });
      }


      singleSeries.data = seriesData;
      seriesList.push(singleSeries);
    });

    return seriesList;
  }

  getImage(img): Observable<any> {
    return this.httpClient.get(img);
  }


  getSeriesDataLabel(componentData, index) {
    let that = this;
    let kpiFormat = 0;
    let dataLabels = {};
    let kpiConfig = typeof componentData.udf.kpiNumberConfig[index] === 'undefined' ? {} : componentData.udf.kpiNumberConfig[index];
    kpiFormat = kpiConfig.kpiNumberFormat;
    kpiFormat = !kpiFormat ? 0 : kpiFormat;
    let chartLabelSettings = (kpiConfig && kpiConfig.kpiNumericConfig && kpiConfig.kpiNumericConfig.showNumericConfig) ? kpiConfig.kpiNumericConfig.showNumericConfig : false;


    if (chartLabelSettings) {
      let x = kpiConfig.kpiNumericConfig && kpiConfig.kpiNumericConfig.xPositionOffset ? kpiConfig.kpiNumericConfig.xPositionOffset : 2;

      //When chart chart Label Alignment is greater then 90 y co-ordinate needed
      let y = !kpiConfig.kpiNumericConfig.yPositionOffset && kpiConfig.kpiNumericConfig.chartLabelAlignment > 90 ?
        -12 : kpiConfig.kpiNumericConfig.yPositionOffset;

      dataLabels = {
        enabled: true,
        rotation: kpiConfig.kpiNumericConfig.chartLabelAlignment,
        x: x,
        y: y,
        crop: kpiConfig.kpiNumericConfig.crop,
        allowOverlap: kpiConfig.kpiNumericConfig.allowOverlap,
        color: kpiConfig.kpiNumericConfig.chartLabelColor,
        style: {
          fontWeight: 'bold',
          fontSize: kpiConfig.kpiNumericConfig.chartLabelFontSize
        }
      }
      if (kpiFormat == -1) {
        dataLabels["formatter"] = function () {
          let val = this.y;
          if (!val) {
            val = 0;
          }
          let cVal = "" + val;
          if (val >= 1000000000) { cVal = (val / 1000000000).toFixed(2) + 'B'; }
          else if (val >= 1000000) { cVal = (val / 1000000).toFixed(2) + 'M'; }
          else if (val >= 1000) { cVal = (val / 1000).toFixed(2) + 'K'; }
          else { cVal = (val).toFixed(0) }

          let v = cVal.split(".");
          if (v[1] == "00B" || v[1] == "00M" || v[1] == "00K") {
            cVal = v[0] + v[1].replace("00", "");
          }
          if (componentData.dataFilter[index].isThousandSeperator)
            cVal = that.commonService.formatNumberString(cVal, true);
          else
            cVal = that.commonService.formatNumberString(cVal, false);
          return cVal;
        }
      }
      else {
        dataLabels["formatter"] = function () {
          if (componentData.dataFilter[index].isThousandSeperator)
            return that.commonService.formatNumberString(this.y.toFixed(kpiFormat), true)+`${(componentData.kpiType == "numeric" && componentData.fetchDataFor == 'bar' && componentData.dataFilter[index].displayType == 'percentage') ? "%" : ""}`;//added by ravi
          else
            return that.commonService.formatNumberString(this.y.toFixed(kpiFormat), false)+`${(componentData.kpiType == "numeric" && componentData.fetchDataFor == 'bar' && componentData.dataFilter[index].displayType == 'percentage') ? "%" : ""}`;//added by ravi
        }
      }
    }
    return dataLabels;
  }

  //isConsolidateData if true do not perform copying
  getDataTable(graphData: any, pageIn, isConsolidateData): any {
    let Response = { Site: [], ValueFilter: [], Data: [], Color: {}, dataL: 0, hasZone: false, isThousandSeperator: {}, formatNumber: {}, totals: { row: true, column: true }, calculatedKpis: {} };
    if (graphData.dataFilter && graphData.dataFilter.constructor == Array && graphData.dataFilter.length > 0) {
      if (graphData.udf.hasOwnProperty('isColumnTotal'))
        Response.totals.column = graphData.udf.isColumnTotal;
      if (graphData.udf.hasOwnProperty('isRowTotal'))
        Response.totals.row = graphData.udf.isRowTotal;
      //create site and value array

      //sort data
      // try {
      //   graphData.dataFilter = graphData.dataFilter.sort((c, d) => (c.data && d.data) && (c.data.length > d.data.length) ? -1 : 1);
      // } catch (err) { }

      this.hour = this.getHours();
      this.week = this.getWeekDays();
      this.month = this.getMonths();

      graphData
        .dataFilter
        .forEach((df, idx) => {
          let lbl = df.label;
          // Response.Color[lbl] = df.color;
          // Response.isThousandSeperator[lbl] = df.isThousandSeperator;
          // Response.formatNumber[lbl] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          let sc = df
            .label
            .split("::");
          if (sc.length == 2) {
            if (Response.Site.indexOf(sc[0]) == -1) {
              Response.Site.push(sc[0]);
            }
            if (Response.ValueFilter.indexOf(sc[1]) == -1) {
              // Response.ValueFilter.push(sc[1]+"\xa0\xa0\xa0\xa0\xa0\xa0");
              Response.ValueFilter.push(sc[1]);
            }
            Response.Color[sc[0]] = df.color;
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[1]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[1]] = df.isThousandSeperator;
            Response.formatNumber[sc[1]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          } else if (sc.length == 3) {
            Response.hasZone = true;
            if (Response.Site.indexOf(sc[0]) == -1) {
              Response.Site.push(sc[0] + "::" + sc[1]);
            }
            if (Response.ValueFilter.indexOf(sc[2]) == -1) {
              // Response.ValueFilter.push(sc[2]+"\xa0\xa0\xa0\xa0\xa0\xa0");
              Response.ValueFilter.push(sc[2]);
            }
            Response.Color[sc[0] + "::" + sc[1]] = df.color;
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[2]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[2]] = df.isThousandSeperator;
            Response.formatNumber[sc[2]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          }
          else {
            if (Response.ValueFilter.indexOf(sc[0]) == -1) {
              Response.ValueFilter.push(sc[0]);
            }
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[0]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[0]] = df.isThousandSeperator;
            Response.formatNumber[sc[0]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          }
        });

      //make all filters data length same and sort
      graphData
        .dataFilter
        .forEach((df, i) => {

          // if (!isConsolidateData) {
          // //This will help for maintaining every coloumn with same length
          for (let j = 0; j < graphData.dataFilter.length; j++) {
            let tempData = [];
            let dfData = JSON.parse(JSON.stringify(graphData.dataFilter[j].data));

            if (i != j) {
              tempData = dfData.map(d => { d.value = 0; return d; });
              graphData.dataFilter[i].data.push(...tempData);
            }
            // console.log(graphData.dataFilter[i].data)

            // graphData.dataFilter[i].data = graphData.dataFilter[i].data.sort((c, d) => new Date(c.date).getTime() - new Date(d.date).getTime());
          }

          const sampleD = new Set(graphData.dataFilter[i].data.map((ll) => ll.date));
          let ss = Array.from(sampleD).map(datef => {
            let vs1 = graphData.dataFilter[i].data.filter(d => d.date === datef);
            let vs = vs1.filter(v => v.value != 0);
            if (vs.length == 0) {
              vs = vs1;
            }
            return vs[0];
          });
          graphData.dataFilter[i].data = ss;
         
          // graphData.dataFilter[i].data.sort((a,b)=>a.date.getTime()-b.date.getTime());
          if (graphData.timeFrame === 'hour' && graphData.udf.consolidateData===0 && (graphData.udf.consolidateDate===0 || graphData.udf.consolidateDate==undefined)) {
            graphData.dataFilter[i].data.sort((c, d) => {
              let aa = moment.utc(c.date,'DD-MM-YYYY HH:mm').valueOf();
              let bb = moment.utc(d.date,'DD-MM-YYYY HH:mm').valueOf();
              return aa > bb ? 1 : aa < bb ? -1 : 0;
            });
          }

          if (graphData.timeFrame === 'dayOfMonth' && graphData.udf.consolidateData===0 && (graphData.udf.consolidateDate===0 || graphData.udf.consolidateDate==undefined)) {
            graphData.dataFilter[i].data.sort((c, d) => moment(c.date, 'DD-MM-YYYY').diff(moment(d.date, 'DD-MM-YYYY')));
          }
          //added by ravi
          if (graphData.timeFrame === 'month' && graphData.udf.consolidateData===0 && (graphData.udf.consolidateDate===0 || graphData.udf.consolidateDate==undefined)) {
            graphData.dataFilter[i].data.sort((c, d) => moment(c.date, 'MM-YYYY').diff(moment(d.date, 'MM-YYYY')));
          }

        });

      //create data rows
      graphData
        .dataFilter
        .forEach((df, i) => {
          let sc = df
            .label
            .split("::");
          let lbl = df.label;
          let mainRow: any = {};
          /*
          //example is creating like:
          {
            Label: "Dubai Mall",
            Footfall: 0,
            zone: 0,
            ZoneO: 10,
            date: 12-2018
          }

          */

          //site or brand
          if (sc.length == 2) {
            // lbl = sc[1]+"\xa0\xa0\xa0\xa0\xa0\xa0";
            lbl = sc[1];

            mainRow.Label = sc[0];
          }
          else if (sc.length == 3) {
            // lbl = sc[2]+"\xa0\xa0\xa0\xa0\xa0\xa0";
            lbl = sc[2];
            mainRow.Label = sc[0] + "::" + sc[1];
          }
          Response
            .ValueFilter
            .forEach(v => {
              mainRow[v] = 0;
            });

          let responseData = [];
          df.data
            .forEach((d) => {
              let row = Object.assign({}, mainRow);
              row[lbl] = d.value;
              // if (graphData.udf.axisConfig) {
              //   let decimals = (df.showOnAxis == "y1"
              //     ? graphData.udf.axisConfig.y1.decimals
              //     : graphData.udf.axisConfig.y2.decimals);
              //   if (decimals != 0) {
              //     try {
              //       row[lbl] = parseFloat(d.value.toFixed(decimals));
              //     } catch (e) {
              //       row[lbl] = parseFloat(d.value);
              //     }
              //   } else {
              //     row[lbl] = Math.round(d.value);
              //   }
              // }

              //set date
              if (graphData.udf.consolidateData || graphData.timeFrame == "dayOfWeek" || graphData.timeFrame == 'week') {
                if (graphData.timeFrame == 'month') {
                  row.date = this.month[d.date - 1];
                }
                if (graphData.timeFrame == 'dayOfWeek') {
                  if (!graphData.udf.consolidateData) {
                    let w = d.date.split("|");
                    row.date = this.week[w[0] - 1] + " " + w[1];
                  } else {
                    row.date = this.week[d.date - 1];
                  }
                }
                if (graphData.timeFrame == 'dayOfMonth') {
                  row.date = d.date;
                }
                if (graphData.timeFrame == 'week') {
                  row.date = "week " + d.date;
                }
                if (graphData.timeFrame == 'year') {
                  row.date = d.date;
                }
                if (graphData.timeFrame == 'hour') {
                  d.date = (d.date > 9 ? '' : '0') + d.date;
                  row.date = d
                    .date
                    .substr(d.date.length - 2, d.date.length) + ':00';
                }
                if (graphData.timeFrame == 'custom') {
                  row.date = d.date;
                }

              } else {
                row.date = d.date;
              }
              responseData.push(row);
              // Response.Data.push(row);
            });


          Response.dataL = Response.dataL > responseData.length ? Response.dataL : responseData.length;
          //slice data
          if (pageIn.pageIn != -1 && pageIn.pageSize != -1) {
            responseData = responseData.slice(pageIn.pageIn, pageIn.pageSize);
          }


          // //This for case when data length is 0 then we have to show label in table

          let tempData = df.data.slice(pageIn.pageIn, pageIn.pageSize);
          if (tempData && tempData.length == 0) {
            let row = Object.assign({}, mainRow);
            responseData.push(row);
          }

          Response.Data.push(...responseData);
        });


      Response.Data.forEach(_dataem => {
        if (Response.hasZone) {
          var list = _dataem.Label.split('::');
          _dataem['Site'] = list[0];
          _dataem['Zone'] = list[1];
        }
        else {
          _dataem['Site'] = _dataem.Label;
        }
        delete _dataem.Label;
      });
    }

    return Response;
  }

  getSpecificDate(groupByTimeFrame: string, showSpecificDate: any[]) {
    let resSpecificDate: any = [];
    if (groupByTimeFrame && showSpecificDate && showSpecificDate.length > 0) {
      if (groupByTimeFrame === "dayOfWeek") {
        showSpecificDate.forEach((i) => {
          if (!isNaN(i))
            resSpecificDate.push(this.weekDays[i]);
        });
      }
      else if (groupByTimeFrame === "month") {
        showSpecificDate.forEach((i) => {
          if (!isNaN(i))
            resSpecificDate.push(this.months[i]);
        });
      }
      else if (groupByTimeFrame === "hour") {
        if (showSpecificDate && showSpecificDate.length == 0) {
          resSpecificDate = Object.assign([], this.hours);
        }
        else
          resSpecificDate = showSpecificDate;
      }
    }
    return resSpecificDate;
  }

  seriesDataForTrend(trendAr, currentDateTrendC, trendName) {
    let series = [];
    trendAr.forEach((ob, i) => {
      let valu = ob.id == 'isCurrent' ? currentDateTrendC : ob.value.previousV;
      let label = trendName[ob.id];
      series.push({ name: label, data: [valu], color: this.trendColor[Math.floor(Math.random() * 15)] });
      if (ob.id != 'isCurrent') {
        series.push({ name: `%${label.charAt(0)}${label.charAt(5)}`, data: [ob.value.changeInP], color: this.trendColor[Math.floor(Math.random() * 15)] });
      }
    });
    return series;
  }

  getCompareDataTable(graphData: any): any {
    let Response = { Site: [], Data: [], Color: {}, Indicators: { color: false, arrow: false }, footerData: [], isThousandSeperator: {}, formatNumber: {} }, slectedItemKeys = [],
      showValue = graphData.udf.compareConfig.valueType.Value, relativeValueTotals = {}, varName = graphData.udf.compareConfig.valueType.variationName ? graphData.udf.compareConfig.valueType.variationName : 'Variance', difName = graphData.udf.compareConfig.valueType.differenceName ? graphData.udf.compareConfig.valueType.differenceName : 'Difference'
      , segName = graphData.udf.compareConfig.segregateName ? graphData.udf.compareConfig.segregateName : 'Date';
    if (graphData.dataFilter && graphData.dataFilter.constructor == Array && graphData.dataFilter.length > 0) {
      if (graphData.udf.compareConfig.tableIndicator)
        Response.Indicators = graphData.udf.compareConfig.tableIndicator;
      let sampleJObject = {};
      graphData.dataFilter.forEach((df, idx) => {
        let lbl = df.label, siteData = {};
        Response.Color[lbl.replace(/ /g, '_').replace(/::/g, '_')] = df.color;
        Response.isThousandSeperator[lbl.replace(/ /g, '_').replace(/::/g, '_')] = df.isThousandSeperator;
        Response.formatNumber[lbl.replace(/ /g, '_').replace(/::/g, '_')] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
        let sc = df.label.split("::");
        if (sc.length == 2) {
          var item = Response.Site.find(x => x.name == sc[0]);
          if (!item)
            siteData = { name: sc[0], sanitized: sc[0].replace(/ /g, '_').replace(/::/g, '_'), id: df.siteIds[0], ValueFilter: [{ name: segName, sort: 'date' }] };

          if (!item)
            siteData["ValueFilter"].push({ name: sc[1], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });
          else
            item["ValueFilter"].push({ name: sc[1], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });

          if (!item)
            Response.Site.push(siteData);
        } else if (sc.length == 3) {
          var item = Response.Site.find(x => x.name == (sc[0] + "::" + sc[1]));
          if (!item)
            siteData = { name: sc[0] + "::" + sc[1], sanitized: (sc[0] + "_" + sc[1]).replace(/ /g, '_'), id: df.siteIds[0], ValueFilter: [{ name: segName, sort: 'date' }] };

          if (!item)
            siteData["ValueFilter"].push({ name: sc[2], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });
          else
            item["ValueFilter"].push({ name: sc[2], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });

          if (!item)
            Response.Site.push(siteData);
        }
        else {
          var item = Response.Site.find(x => x.name == (sc[0] + "::" + sc[1] + "::" + sc[2]));
          if (!item)
            siteData = { name: sc[0] + "::" + sc[1] + "::" + sc[2], sanitized: (sc[0] + "_" + sc[1] + "_" + sc[2]).replace(/ /g, '_'), id: df.siteIds[0], ValueFilter: [{ name: segName, sort: 'date' }] };

          if (!item)
            siteData["ValueFilter"].push({ name: sc[3], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });
          else
            item["ValueFilter"].push({ name: sc[3], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });

          if (!item)
            Response.Site.push(siteData);
        }
      });

      Response.Site.forEach(_site => {
        _site.ValueFilter.forEach(_vf => {
          sampleJObject[_site.sanitized + "_" + _vf.name.replace(/ /g, '_')] = '';
          if (_vf.selected)
            slectedItemKeys.push(_site.sanitized + "_" + _vf.name.replace(/ /g, '_'))
        });
      });


      graphData.dataFilter.forEach(df => {
        let lbl = df.label.replace(/::/g, '_').replace(/ /g, '_');
        if (!(df.var || df.diff)) {
          var datelbl = df.label.split('::');
          datelbl[datelbl.length - 1] = segName;
          datelbl = datelbl.join('_').replace(/ /g, '_');
          df.data.forEach((_dataItem, i) => {
            if (Response.Data[i]) {
              Response.Data[i][lbl] = _dataItem.value;
              Response.Data[i][datelbl] = _dataItem.date;
            }
            else {
              const sampleItem = Object.assign({}, sampleJObject);
              sampleItem[lbl] = _dataItem.value;
              sampleItem[datelbl] = _dataItem.date;
              Response.Data.push(sampleItem)
            }
          });
        }
        else {
          relativeValueTotals[lbl] = df["reltotal"];
          var datelbl = df.label.split('::');
          if (!showValue) {
            datelbl[datelbl.length - 1] = segName;
            datelbl = datelbl.join('_').replace(/ /g, '_');
          }
          df.data.forEach((_dataItem, i) => {
            var val = _dataItem.value;
            if (val != '') {
              if (df.var)
                val = parseFloat(val);
              else
                val = parseInt(val);
            }
            if (Response.Data[i]) {
              Response.Data[i][lbl] = isNaN(val) ? '' : val;
              if (!showValue)
                Response.Data[i][datelbl] = _dataItem.date;
            }
            else {
              const sampleItem = Object.assign({}, sampleJObject);
              sampleItem[lbl] = isNaN(val) ? '' : val;
              if (!showValue)
                sampleItem[datelbl] = _dataItem.date;
              Response.Data.push(sampleItem)
            }
          });
        }
      });

      if (Response.Data.length > 0) {
        var iterate = Math.ceil(Object.keys(sampleJObject).length / slectedItemKeys.length);
        var newArray = [];
        slectedItemKeys.forEach(_x => {
          newArray = newArray.concat(new Array(iterate).fill(_x));
        });
        slectedItemKeys = newArray;

        let aggreFunctions = []
        if (graphData.udf.compareConfig.tableAggregator) {
          Object.keys(graphData.udf.compareConfig.tableAggregator).forEach(_key => {
            if (graphData.udf.compareConfig.tableAggregator[_key])
              aggreFunctions.push(_key);
          })
        }

        aggreFunctions.forEach(_ags => {
          const sampleItem = Object.assign({}, sampleJObject);
          Object.keys(sampleItem).forEach((_key, ix) => {
            if (_key.indexOf('_' + segName) > -1) {
              sampleItem[_key] = (graphData.udf.compareConfig.aggregatorNames ? graphData.udf.compareConfig.aggregatorNames[_ags + "Name"] : this.capitalizeFirstLetter(_ags));
              return;
            }
            switch (_ags) {
              case 'total':
                var lastVal: any = _key.split('_');
                lastVal = lastVal[lastVal.length - 1];
                if (lastVal === difName) {
                  let selectedValue = sampleItem[slectedItemKeys[ix]];
                  // let relativeValue = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b))); 
                  let relativeValue = relativeValueTotals[_key];

                  if (selectedValue !== '') {
                    let diff = selectedValue - relativeValue;
                    if (diff > 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + diff + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    else if (diff < 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + diff + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    else
                      sampleItem[_key] = 0;
                  }
                  else {
                    if (relativeValue > 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + relativeValue + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    else if (relativeValue < 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + relativeValue + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    else
                      sampleItem[_key] = 0;
                  }
                }
                else if (lastVal === varName) {
                  var selectedValue = sampleItem[slectedItemKeys[ix]];
                  // let relativeValue = sampleItem[_key.replace('_Variance', '')];
                  // let relativeValue = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                  let relativeValue = relativeValueTotals[_key];
                  if (selectedValue !== '') {
                    let variance = (parseFloat(((selectedValue - relativeValue) * 100 / relativeValue).toFixed(2)));
                    if (!isFinite(variance)) {
                      if ((selectedValue - relativeValue) > 0)
                        variance = 100;
                      else
                        variance = -100;
                    }
                    if (selectedValue === 0 && relativeValue === 0)
                      variance = 0;
                    if (variance > 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#03c04a"' : '') + '>' + variance + '%' + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    else if (variance < 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + variance + '%' + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    else
                      sampleItem[_key] = 0;
                  }
                  else {
                    if (relativeValue > 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#03c04a"' : '') + '> 100%' + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                    else if (relativeValue < 0)
                      sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '> -100%' + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                    else
                      sampleItem[_key] = 0;
                  }
                }
                else {
                  sampleItem[_key] = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                }
                break;
              case 'count':
                var ttl = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                if (ttl === 0)
                  sampleItem[_key] = Response.Data.filter(x => x[_key] === 0).length;
                else
                  sampleItem[_key] = Response.Data.filter(x => x[_key] !== '').length;
                break;
              case 'min':
                sampleItem[_key] = Math.min.apply(Math, Response.Data.filter(x => x[_key] !== '').map(function (o) { return o[_key]; }));
                sampleItem[_key] = isFinite(sampleItem[_key]) ? sampleItem[_key] : 0;
                break;
              case 'max':
                sampleItem[_key] = Math.max.apply(Math, Response.Data.filter(x => x[_key] !== '').map(function (o) { return o[_key]; }));
                sampleItem[_key] = isFinite(sampleItem[_key]) ? sampleItem[_key] : 0;
                break;
              case 'average':
                let length: any = Response.Data.filter(x => x[_key] !== '').length;
                let sum: any = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                let avg: any = (sum / length).toFixed(2);
                sampleItem[_key] = isNaN(avg) ? 0 : parseFloat(avg);
                break;
              default:
                break;
            }
          });
          Response.footerData.push(sampleItem);
        });
      }
    }
    return Response;
  }

  getCompareDateDataTable(graphData: any, pageIn): any {
    if(graphData.udf.compareDateConfig.compareType == 'aggregate'){
      let Response = { Site: [], ValueFilter: [], Data: [], Color: {}, dataL: 0, hasZone: false, isThousandSeperator: {}, formatNumber: {}, totals: { row: true, column: true }, calculatedKpis: {} };
      if (graphData.dataFilter && graphData.dataFilter.constructor == Array && graphData.dataFilter.length > 0) {
        if (graphData.udf.hasOwnProperty('isColumnTotal'))
          Response.totals.column = graphData.udf.isColumnTotal;
        if (graphData.udf.hasOwnProperty('isRowTotal'))
          Response.totals.row = graphData.udf.isRowTotal;
        //create site and value array
  
        graphData.dataFilter.forEach((df, idx) => {
          let lbl = df.label;
          let sc = df .label .split("::");
          if (sc.length == 2) {
            if (Response.Site.indexOf(sc[0]) == -1) {
              Response.Site.push(sc[0]);
            }
            if (Response.ValueFilter.indexOf(sc[1]) == -1) {
              Response.ValueFilter.push(sc[1]);
            }
            Response.Color[sc[0]] = df.color;
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[1]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[1]] = df.isThousandSeperator;
            Response.formatNumber[sc[1]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          } else if (sc.length == 3) {
            Response.hasZone = true;
            if (Response.Site.indexOf(sc[0]) == -1) {
              Response.Site.push(sc[0] + "::" + sc[1]);
            }
            if (Response.ValueFilter.indexOf(sc[2]) == -1) {
              // Response.ValueFilter.push(sc[2]+"\xa0\xa0\xa0\xa0\xa0\xa0");
              Response.ValueFilter.push(sc[2]);
            }
            Response.Color[sc[0] + "::" + sc[1]] = df.color;
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[2]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[2]] = df.isThousandSeperator;
            Response.formatNumber[sc[2]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          }
          else {
            if (Response.ValueFilter.indexOf(sc[0]) == -1) {
              Response.ValueFilter.push(sc[0]);
            }
            if (df.calculatedTotal) {
              Response.calculatedKpis[sc[0]] = df.calculatedTotal;
            }
            Response.isThousandSeperator[sc[0]] = df.isThousandSeperator;
            Response.formatNumber[sc[0]] = graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          }
        });
  
        //make all filters data length same and sort
        graphData.dataFilter.forEach((df, i) => {
          for (let j = 0; j < graphData.dataFilter.length; j++) {
            let tempData = [];
            let dfData = JSON.parse(JSON.stringify(graphData.dataFilter[j].data));
  
            if (i != j) {
              tempData = dfData.map(d => { d.value = 0; return d; });
              graphData.dataFilter[i].data.push(...tempData);
            }
          }
  
          const sampleD = new Set(graphData.dataFilter[i].data.map((ll) => ll.date));
          let ss = Array.from(sampleD).map(datef => {
            let vs1 = graphData.dataFilter[i].data.filter(d => d.date === datef);
            let vs = vs1.filter(v => v.value != 0);
            if (vs.length == 0) {
              vs = vs1;
            }
            return vs[0];
          });
          graphData.dataFilter[i].data = ss;
  
        });
  
        //create data rows
        graphData.dataFilter.forEach((df, i) => {
            let sc = df.label.split("::");
            let lbl = df.label;
            let mainRow: any = {};
            /*
            //example is creating like:
            {
              Label: "Dubai Mall",
              Footfall: 0,
              zone: 0,
              ZoneO: 10,
              date: 12-2018
            }
  
            */
  
            //site or brand
            if (sc.length == 2) {
              lbl = sc[1];
  
              mainRow.Label = sc[0];
            }
            else if (sc.length == 3) {
              lbl = sc[2];
              mainRow.Label = sc[0] + "::" + sc[1];
            }
            Response.ValueFilter.forEach(v => { mainRow[v] = 0; });
  
            let responseData = [];
            df.data.forEach((d) => {
                let row = Object.assign({}, mainRow);
                row[lbl] = d.value;
  
                //set date
                row.date = d.date;
                responseData.push(row);
                // Response.Data.push(row);
              });
  
  
            Response.dataL = Response.dataL > responseData.length ? Response.dataL : responseData.length;
            //slice data
            if (pageIn.pageIn != -1 && pageIn.pageSize != -1) {
              responseData = responseData.slice(pageIn.pageIn, pageIn.pageSize);
            }
            // //This for case when data length is 0 then we have to show label in table
  
            let tempData = df.data.slice(pageIn.pageIn, pageIn.pageSize);
            if (tempData && tempData.length == 0) {
              let row = Object.assign({}, mainRow);
              responseData.push(row);
            }
  
            Response.Data.push(...responseData);
          });
  
  
        Response.Data.forEach(_dataem => {
          if (Response.hasZone) {
            var list = _dataem.Label.split('::');
            _dataem['Site'] = list[0];
            _dataem['Zone'] = list[1];
          }
          else {
            _dataem['Site'] = _dataem.Label;
          }
          delete _dataem.Label;
        });
      }
  
      return Response;
    }
  }

  getCompareDayTable(graphData: any, pageIn){
      let Response = { Site: [], Data: [], Color: {}, Indicators: { color: false, arrow: false }, footerData: [], isThousandSeperator: {}, formatNumber: {}}, slectedItemKeys = [],
      showValue = graphData.udf.compareDateConfig.valueType.Value, relativeValueTotals = {}, customizedValue = {}, 
      varName = graphData.udf.compareDateConfig.valueType.variationName ? graphData.udf.compareDateConfig.valueType.variationName : 'Variance', 
      difName = graphData.udf.compareDateConfig.valueType.differenceName ? graphData.udf.compareDateConfig.valueType.differenceName : 'Difference';
      
      if (graphData.dataFilter && graphData.dataFilter.constructor == Array && graphData.dataFilter.length > 0) {
        if (graphData.udf.compareDateConfig.tableIndicator)
          Response.Indicators = graphData.udf.compareDateConfig.tableIndicator;
        let sampleJObject = {};
        graphData.dataFilter.forEach((df, idx) => {
          let lbl = df.label, siteData = {};
          Response.Color[lbl.replace(/ /g, '_').replace(/::/g, '_')] = df.color;
          Response.isThousandSeperator[lbl.replace(/ /g, '_').replace(/::/g, '_')] = df.isThousandSeperator;
          Response.formatNumber[lbl.replace(/ /g, '_').replace(/::/g, '_')] = df.type == 0 ? 0 : graphData.udf.kpiNumberConfig[idx].kpiNumberFormat;
          let sc = df.label.split("::");
          if (sc.length == 2) {
            var item = Response.Site.find(x => x.name == sc[0]);
            if (!item)
              siteData = { name: sc[0], sanitized: sc[0].replace(/ /g, '_').replace(/::/g, '_'), id: df.siteIds[0], ValueFilter: [] };

            if (!item)
              siteData["ValueFilter"].push({ name: sc[1], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });
            else
              item["ValueFilter"].push({ name: sc[1], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });

            if (!item)
              Response.Site.push(siteData);
          } else if (sc.length == 3) {
            var item = Response.Site.find(x => x.name == (sc[0] + "::" + sc[1]));
            if (!item)
              siteData = { name: sc[0] + "::" + sc[1], sanitized: (sc[0] + "_" + sc[1]).replace(/ /g, '_'), id: df.siteIds[0], ValueFilter: [] };

            if (!item)
              siteData["ValueFilter"].push({ name: sc[2], sort: (df.var || df.diff) ? 'variance' :'int', selected: df.selected });
            else
              item["ValueFilter"].push({ name: sc[2], sort: (df.var || df.diff) ? 'variance' :'int', selected: df.selected });

            if (!item)
              Response.Site.push(siteData);
          }
          else {
            var item = Response.Site.find(x => x.name == (sc[0] + "::" + sc[1] + "::" + sc[2]));
            if (!item)
              siteData = { name: sc[0] + "::" + sc[1] + "::" + sc[2], sanitized: (sc[0] + "_" + sc[1] + "_" + sc[2]).replace(/ /g, '_'), id: df.siteIds[0], ValueFilter: [] };

            if (!item)
              siteData["ValueFilter"].push({ name: sc[3], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });
            else
              item["ValueFilter"].push({ name: sc[3], sort: (df.var || df.diff) ? 'variance' : 'int', selected: df.selected });

            if (!item)
              Response.Site.push(siteData);
          }
        });

        Response.Site.forEach(_site => {
          _site.ValueFilter.forEach(_vf => {
            sampleJObject[_site.sanitized + "_" + _vf.name.replace(/ /g, '_')] = '';
            if (_vf.selected)
              slectedItemKeys.push(_site.sanitized + "_" + _vf.name.replace(/ /g, '_'))
          });
        });


        graphData.dataFilter.forEach(df => {
          let lbl = df.label.replace(/::/g, '_').replace(/ /g, '_');
          if (!(df.var || df.diff)) {
            var datelbl = df.label.split('::');
            datelbl = datelbl.join('_').replace(/ /g, '_');
            df.data.forEach((_dataItem, i) => {
              if (Response.Data[i]) {
                Response.Data[i][lbl] = _dataItem.value;
              }
              else {
                const sampleItem = Object.assign({}, sampleJObject);
                sampleItem[lbl] = _dataItem.value;
                Response.Data.push(sampleItem)
              }
            });
          }
          else {
            relativeValueTotals[lbl] = df["reltotal"];
            var datelbl = df.label.split('::');
            df.data.forEach((_dataItem, i) => {
              var val = _dataItem.value;
              if (val != '') {
                if (df.var)
                  val = parseFloat(val);
                else
                  val = parseInt(val);
              }
              if (Response.Data[i]) {
                Response.Data[i][lbl] = isNaN(val) ? '' : val;
              }
              else {
                const sampleItem = Object.assign({}, sampleJObject);
                sampleItem[lbl] = isNaN(val) ? '' : val;
                Response.Data.push(sampleItem)
              }
            });
          }
          if(df.day){
            customizedValue[lbl] = df.day;
          }
        });

        if (Response.Data.length > 0){
          var iterate = Math.ceil(Object.keys(sampleJObject).length / slectedItemKeys.length);
          var newArray = [];
          slectedItemKeys.forEach(_x => {
            newArray = newArray.concat(new Array(iterate).fill(_x));
          });
          slectedItemKeys = newArray;

          let aggreFunctions = []
          if (graphData.udf.compareDateConfig.tableAggregator) {
            Object.keys(graphData.udf.compareDateConfig.tableAggregator).forEach(_key => {
              if (graphData.udf.compareDateConfig.tableAggregator[_key])
                aggreFunctions.push(_key);
            })
          }

          aggreFunctions.forEach(_ags => {
            const sampleItem = Object.assign({}, sampleJObject);
            Object.keys(sampleItem).forEach((_key, ix) => {
              if (ix <= 2) {
                sampleItem[_key] = (graphData.udf.compareDateConfig.aggregatorNames ? graphData.udf.compareDateConfig.aggregatorNames[_ags + "Name"] : this.capitalizeFirstLetter(_ags));
                return;
              }
              switch (_ags) {
                case 'total':
                  var lastVal: any = _key.split('_');
                  lastVal = lastVal[lastVal.length - 1];
                  if (lastVal === difName) {
                    let selectedValue = sampleItem[slectedItemKeys[ix]];
                    let relativeValue = relativeValueTotals[_key];
      
                    if (selectedValue !== '') {
                      let diff = selectedValue - relativeValue;
                      if (diff > 0)
                        sampleItem[_key] = '<span >' + diff + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else if (diff < 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + diff + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        sampleItem[_key] = 0;
                    }
                    else {
                      if (relativeValue > 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#000000"' : '') + '>' + relativeValue + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else if (relativeValue < 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + relativeValue + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        sampleItem[_key] = 0;
                    }
                  }
                  else if (lastVal === varName) {
                    let selectedValue = sampleItem[slectedItemKeys[ix]];
                    let relativeValue = relativeValueTotals[_key];
                    if (selectedValue !== '') {
                      let variance = (parseFloat(((selectedValue - relativeValue) * 100 / relativeValue).toFixed(2)));
                      if (!isFinite(variance)) {
                        if ((selectedValue - relativeValue) > 0)
                          variance = 100;
                        else
                          variance = -100;
                      }
                      if (selectedValue === 0 && relativeValue === 0)
                        variance = 0;
                      if (variance > 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#000000"' : '') + '>' + variance + '%' + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else if (variance < 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '>' + variance + '%' + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        sampleItem[_key] = 0;
                    }
                    else {
                      if (relativeValue > 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#000000"' : '') + '> 100%' + (Response.Indicators.arrow ? '&nbsp;&#x25B2;' : '') + '</span>';
                      else if (relativeValue < 0)
                        sampleItem[_key] = '<span ' + (Response.Indicators.color ? 'style="color:#ff0000"' : '') + '> -100%' + (Response.Indicators.arrow ? '&nbsp;&#x25BC;' : '') + '</span>';
                      else
                        sampleItem[_key] = 0;
                    }
                  }
                  else {
                    sampleItem[_key] = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                  }
                  break;
                case 'count':
                  var ttl = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                  if (ttl === 0)
                    sampleItem[_key] = Response.Data.filter(x => x[_key] === 0).length;
                  else
                    sampleItem[_key] = Response.Data.filter(x => x[_key] !== '').length;
                  break;
                case 'min':
                  sampleItem[_key] = Math.min.apply(Math, Response.Data.filter(x => x[_key] !== '').map(function (o) { return o[_key]; }));
                  sampleItem[_key] = isFinite(sampleItem[_key]) ? sampleItem[_key] : 0;
                  break;
                case 'max':
                  sampleItem[_key] = Math.max.apply(Math, Response.Data.filter(x => x[_key] !== '').map(function (o) { return o[_key]; }));
                  sampleItem[_key] = isFinite(sampleItem[_key]) ? sampleItem[_key] : 0;
                  break;
                case 'average':
                  let length: any = Response.Data.filter(x => x[_key] !== '').length;
                  if(customizedValue[_key] && customizedValue[_key] >= 0){
                    length = customizedValue[_key];
                  }
                  let sum: any = parseInt(Response.Data.map(x => x[_key]).reduce((a, b) => Number(a) + Number(b)));
                  let avg: any = (sum / length).toFixed(2);
                  sampleItem[_key] = '<span style="color:#000000" >' + (isNaN(avg) ? 0 : parseFloat(avg)) + '</span>';
                  break;
                case 'weekday':
                  var lastVal: any = _key.split('_');
                  lastVal = lastVal[lastVal.length - 1];
                  sampleItem[_key] = 0;
                  if (lastVal !== difName && lastVal !== varName) {
                    if(lastVal == 'LY'){
                      let weekday = Response.Data.filter(i => i.Period_to_DayLY != "Friday" &&  i.Period_to_DayLY != "Saturday" ).map(x => x[_key]).reduce((a, b) => Number(a) + Number(b));
                      sampleItem[_key] = weekday;
                    }else{
                      let weekday = Response.Data.filter(i => i.Period_to_Day != "Friday" &&  i.Period_to_Day != "Saturday" ).map(x => x[_key]).reduce((a, b) => Number(a) + Number(b));
                      sampleItem[_key] = weekday;
                    }
                  }else{
                    if(lastVal == difName){
                      let cYear = sampleItem[_key.replace(`_${difName}`,'')];
                      let lYear = sampleItem[_key.replace(`${difName}`,'LY')];
                      let weekday = cYear - lYear;
                      sampleItem[_key] = weekday;
                    }
                    if(lastVal == varName){
                      let dYear = sampleItem[_key.replace(`${varName}`,difName)];
                      let lYear = sampleItem[_key.replace(`${varName}`,'LY')];
                      let weekday = (dYear/lYear) * 100;
                      if (!isFinite(weekday)) {
                        if ((dYear - lYear) > 0)
                          weekday = 100;
                        else
                          weekday = -100;
                      }
                      sampleItem[_key] = weekday;
                    }
                  }
                  break;
                case 'weekend':
                  var lastVal: any = _key.split('_');
                  lastVal = lastVal[lastVal.length - 1];
                  sampleItem[_key] = 0;
                  if (lastVal !== difName && lastVal !== varName) {
                    if(lastVal == 'LY'){
                      let weekend = Response.Data.filter(i => i.Period_to_DayLY == "Friday" ||  i.Period_to_DayLY == "Saturday" );
                      if(weekend.length){
                        weekend = weekend.map(x => x[_key]);
                        if(weekend.length){
                          weekend = weekend.reduce((a, b) => Number(a) + Number(b));
                        }
                      }
                      sampleItem[_key] = weekend;
                    }else{
                      let weekend = Response.Data.filter(i => i.Period_to_Day == "Friday" ||  i.Period_to_Day == "Saturday" );
                      if(weekend.length){
                        weekend = weekend.map(x => x[_key]);
                        if(weekend.length){
                          weekend = weekend.reduce((a, b) => Number(a) + Number(b));
                        }
                      }
                      sampleItem[_key] = weekend || 0;
                    }
                  }else{
                    if(lastVal == difName){
                      let cYear = sampleItem[_key.replace(`_${difName}`,'')];
                      let lYear = sampleItem[_key.replace(`${difName}`,'LY')];
                      let weekend = cYear - lYear;
                      sampleItem[_key] = weekend;
                    }
                    if(lastVal == varName){
                      let dYear = sampleItem[_key.replace(`${varName}`,difName)];
                      let lYear = sampleItem[_key.replace(`${varName}`,'LY')];
                      let weekend = (dYear/lYear) * 100;
                      if (!isFinite(weekend)) {
                        if ((dYear - lYear) > 0)
                          weekend = 100;
                        else
                          weekend = -100;
                      }
                      sampleItem[_key] = weekend;
                    }
                  }
                  break;
                default:
                  break;
              }
            });
            Response.footerData.push(sampleItem);
          })
        }
      }
      return Response;
  }

  capitalizeFirstLetter(string): any {
    return string[0].toUpperCase() + string.slice(1);
  }
}



// WEBPACK FOOTER //
// D:/Xpand-Dubai/xpand_retail_int/Customers/app/src/app/shared/components/graphs/widget-helper.service.ts